import React, { useContext } from "react";
import InputField from "../../../lib/ui/inputs/Input";
import "../Styles.css";
import "./doctorInvites.css";

import "../../../ui-styles/list/FormList.css";
import { LangCtx } from "../../../lib/context";

const DoctorInviteForm = (props) => {
    const { l } = useContext(LangCtx);
    const { error } = props;
    return (
        <div className="flexCol pdngSM">
            <div className="flexRow pdngXS">
                <span className="lightTxt">{l.invite_subhdng}</span>
            </div>
            <div className="flexWrap">
                <div className="halfWidth pdngXS">
                    <InputField
                        placeholder={l.username}
                        type="text"
                        maxLength="30"
                        value={props.formData.name}
                        error={error && error.name}
                        errorMsg={error.name}
                        onChange={(e) => props.handleChange("name", e.target.value)}
                    />
                </div>
                <div className="halfWidth pdngXS">
                    <InputField
                        placeholder={l.email_address}
                        type="text"
                        maxLength="50"
                        value={props.formData.email}
                        error={error && error.email}
                        errorMsg={error.email}
                        onChange={(e) => props.handleChange("email", e.target.value)}
                    />
                </div>
                <div className="btnGroup flxEnd pd120">
                    <button className="btnFilled sm ripple" onClick={props.handleCreateInvitee}>
                        <span>{l.addbtn}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DoctorInviteForm;
